import React, { useState, useEffect, useRef } from "react";
import { Col } from "react-bootstrap";
import { Line, Bar } from "react-chartjs-2";
import {
	formatBigNum,
	chartBgc,
	chartWatermark,
	chartDataSorter,
	getNextSunday,
} from "../utils";
import moment from "moment";

const SearchChart = ({
	dataFetched,
	isLoading,
	chartData = [],
	graphRef,
	title,
	displayedDates,
	setDisplayedDates,
	volume,
	setVolume,
	selectedDomains,
	startDate,
	endDate,
}) => {
	const [dataDict, setDataDict] = useState({});

  const colors = [
    "#1f77b4", // Blue
    "#ff7f0e", // Orange
    "#2ca02c", // Green
    "#d62728", // Red
    "#9467bd", // Purple
    "#8c564b", // Brown
    "#e377c2", // Pink
    "#7f7f7f", // Gray
    "#bcbd22", // Yellow-Green
    "#17becf"  // Cyan
  ];

	useEffect(() => {
		const loadDisplayData = () => {
			if (chartData.length === 0) {
        // Reset chart states when chartData is empty
        setDisplayedDates([]);
        setVolume([]);
        setDataDict({});
        return
      };
			chartData.sort(chartDataSorter);

			let dates = generateWeeks();
			let buffer_start = moment(getNextSunday(startDate)).subtract(2, "M");
			let buffer_end = moment(endDate).add(1, "M");
			dates.unshift(buffer_start.format("YYYY-MM-DD"));
			dates.push(buffer_end.format("YYYY-MM-DD"));

			let collections = {};
			for (const domain of selectedDomains) {
				collections[domain.domain] = new Array(dates.length).fill(0);
			}

			let tmpTotal = new Array(dates.length).fill(0);
			for (let data of chartData) {
				// let dateInd = dates.indexOf(data.week);
        let formattedWeek = moment(data.week).format("YYYY-MM-DD");
				let dateInd = dates.indexOf(formattedWeek);
				if (dateInd === -1) {
					console.warn("Date not found in generated dates:", formattedWeek);
					continue;
				}
				let domainInd = data.domain;
				let vol = data.total_volume;
				collections[domainInd][dateInd] += vol;
				tmpTotal[dateInd] += vol;
			}
			setDisplayedDates(dates);
			setVolume(tmpTotal);
			setDataDict(collections);
		};

		const generateWeeks = () => {
			let weeks = [];
			let start = moment(chartData[0].week);
			let end = moment(chartData[chartData.length - 1].week);
			// let start = moment(getNextSunday(startDate));
			// let end = moment(endDate);
			do {
				weeks.push(start.format("YYYY-MM-DD"));
				start.add(7, "d");
			} while (start.isSameOrBefore(end));

			return weeks;
		};

		loadDisplayData();
	}, [dataFetched, chartData]);

	if (isLoading) {
		return <h4 style={{ textAlign: "center" }}>Loading Chart...</h4>;
	} else if (!dataFetched) {
		return "";
	} else {
		return (
			<Col sm={12}>
				<React.Fragment>
					<Line
						ref={graphRef}
						className="history-container"
						height={350}
						data={{
							labels: displayedDates,
							datasets: Object.keys(dataDict).map((domain, index) => {
								return {
									data: dataDict[domain],
									type: "bar",
									label: domain,
									backgroundColor: colors[index % colors.length],
									borderWidth: 1,
								};
							}),
						}}
						options={{
							responsive: true,
							maintainAspectRatio: false,
							scales: {
								xAxes: [
									{
										gridLines: {
											display: false,
										},
										type: "time",
										time: {
											unit: "week",
										},
										ticks: {
                      callback: (value) => moment(value).format("MMM D"),
										},
									},
								],
								yAxes: [
									{
										id: "A",
										type: "linear",
										position: "left",
										gridLines: {
											borderDash: [8, 4],
										},
										ticks: {
											callback: (value) => formatBigNum(value),
										},
									},
								],
							},
							title: {
								display: true,
								text: title,
								fontSize: 15,
							},
							legend: {
								display: true,
							},
							tooltips: {
								mode: "index",
								callbacks: {
									label: function (tooltipItem, data) {
                    console.log(data);
										let value = formatBigNum(tooltipItem.yLabel);
										let label =
											data.datasets[tooltipItem.datasetIndex].label || "";
										if (label) {
											label += ": ";
											label += value;
										}
										return label;
									},
								},
							},
						}}
						plugins={[chartBgc, chartWatermark]}
					/>
				</React.Fragment>
			</Col>
		);
	}
};

export default SearchChart;
